module.exports = __webpack_public_path__ + "img/1.2.d77c65e4.png";